<div class="input-group">
    <input  id="{{ 'disabled' + fieldKey }}" type="text"
        class="form-control has-value color-light-grey-disabledType"
        [formControl]="formControl" [formlyAttributes]="field">
    <label for="DisabledInputField">{{field.templateOptions.label}} </label>
</div>